import React, { useEffect, useState } from "react";

const Countdown = () => {
    const calculateTimeLeft = () => {
        const targetDate = new Date("2025-07-28T00:00:00-05:00"); // Hora Lima
        const now = new Date();
        const difference = targetDate - now;

        if (difference <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        }

        return {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / (1000 * 60)) % 60),
            seconds: Math.floor((difference / 1000) % 60),
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="flex flex-col items-center justify-center bg-white text-blue-900 p-5">
            <h1 className="text-3xl 2xl:text-5xl md:text-4xl font-bold mb-6 text-center">
                Oferta por tiempo limitado
            </h1>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center text-white">
                <div className="bg-blue-900 text-white rounded-2xl shadow-md p-4">
                    <p className="2xl:text-4xl text-3xl font-bold">
                        {timeLeft.days}
                    </p>
                    <p className="text-sm font-medium">Días</p>
                </div>
                <div className="bg-blue-900 text-white rounded-2xl shadow-md p-4">
                    <p className="2xl:text-4xl text-3xl font-bold">
                        {timeLeft.hours}
                    </p>
                    <p className="text-sm font-medium">Horas</p>
                </div>
                <div className="bg-blue-900 text-white rounded-2xl shadow-md p-4">
                    <p className="2xl:text-4xl text-3xl font-bold">
                        {timeLeft.minutes}
                    </p>
                    <p className="text-sm font-medium">Minutos</p>
                </div>
                <div className="bg-blue-900 text-white rounded-2xl shadow-md p-4">
                    <p className="2xl:text-4xl text-3xl font-bold">
                        {timeLeft.seconds}
                    </p>
                    <p className="text-sm font-medium">Segundos</p>
                </div>
            </div>
        </div>
    );
};

export default Countdown;
